import React, { useState, useEffect } from "react";
import AdminDashboard from "../../AdminDashboard"
import { isAuthenticated } from "../../../../auth"
import { Redirect } from "react-router-dom";
import { getGiftType, updateGiftType } from "../../apiAdmin"
import * as qs from 'query-string';
import { default_url } from "../../../..";
import { dict } from "../../../../dictionary";

function UpdateGiftType() {
    const [values, setValues] = useState({
        _id: "",
        name: "",
        value: "",
        numberOfGifts: "",
        showLowerTypes: "",
        error: "",
        redirectToReferrer: false
    });

    const { user, token } = isAuthenticated();
    const { _id, name, value, numberOfGifts, showLowerTypes, error, redirectToReferrer } = values;
    const parsed = qs.parse(window.location.search);

    useEffect(() => {
        async function fetchData() {
            await getGiftType(parsed.gift_type_id, user._id, token)
                .then(res => {
                    if (res.error) {
                        setValues({ ...values, error: res.error, redirectToReferrer: true });
                    } else {
                        setValues({ _id: res._id, name: res.name, value: res.value, numberOfGifts: res.numberOfGifts, showLowerTypes: res.showLowerTypes });
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
        fetchData();
    }, []);

    const handleChange = name => event => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const clickSubmit = (event) => {
        event.preventDefault();
        updateGiftType({ _id, name, value, numberOfGifts, showLowerTypes }, user._id, token)
            .then(data => {
                console.log(data)
                if (data.error) {
                    setValues({ ...values, error: dict[data.error], redirectToReferrer: false });
                } else {
                    setValues({
                        name: "",
                        value: "",
                        numberOfGifts: "",
                        showLowerTypes: "",
                        error: undefined,
                        redirectToReferrer: true
                    });
                }
            })
    }

    const showError = () => {
        return (
            <div className="alert alert-danger" style={{ display: error ? "" : "none", textAlign: 'start' }}>
                {error}
            </div>
        )
    }

    const redirectUser = () => {
        if (redirectToReferrer) {
            return (
                <Redirect to={{ pathname: default_url + 'admin/gift-types', state: { prevPath: "edit", error } }} />
            )
        }
    }

    const showLowerTypesSelector = () => {
        return (
            <select onChange={handleChange("showLowerTypes")} name="showLowerTypes" className="inputField form-control" value={showLowerTypes ? "yes" : "no"}>
                <option value=""></option>
                <option value="no">{dict["no"]}</option>
                <option value="yes">{dict["yes"]}</option>
            </select>
        )
    }

    const arStyleRequiredStart = {
        left: "30px"
    }
    const enStyleRequiredStart = {
        right: "30px"
    }
    const arStylelabel = {
        float: "right"
    }
    const enStylelabel = {
        float: "left"
    }

    const form = () => {
        return (
            <div className="userProfileDataContainer">
                {showError()}
                {redirectUser()}
                <h3 className="formContainerTitle">{dict["edit_gift_type"]}</h3>
                <h6 className="requiredStar requiredStarUserDashbord" style={default_url == "/en/" ? enStyleRequiredStart : arStyleRequiredStart}>{dict["required"]}</h6>
                <form >
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{"ID"}</label>
                    <input type="text" value={_id || ""} className="inputField form-control" disabled ></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["gift_type_name"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("name")} type="text" value={name} className="inputField form-control" id="name" placeholder={dict["gift_type_name"]}></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["gift_type_value"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("value")} type="number" value={value} className="inputField form-control" id="name" placeholder={dict["gift_type_value"]}></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["number_of_gifts"]} <span className="redStar">*</span></label>
                    <input onChange={handleChange("numberOfGifts")} type="number" value={numberOfGifts} className="inputField form-control" id="name" placeholder={dict["number_of_gifts"]}></input>
                    <label className="inputLabel" style={default_url == "/en/" ? enStylelabel : arStylelabel}>{dict["show_lower_types"]} <span className="redStar">*</span></label><br />
                    {showLowerTypesSelector()}
                    <button onClick={clickSubmit} type="submit" className="dashboardBtn">{dict["save"]}</button>
                </form>
            </div>
        )
    }

    return (
        <AdminDashboard
            active="222"
            data={form}
        />
    )
}

export default UpdateGiftType;